export default "__VITE_ASSET__vwaHldrb__"